<template>
  <div style="display: flex;flex-direction: column;width: 100%;margin-top: -10px;">

    <!-- 基本信息 -->
    <div class="order-input-wrap" v-if="orderDetail.desUserId">

      <base-tag label="设计师信息"></base-tag>
      <!-- 设计师昵称 -->
      <div class="input-form-wrap">
        <div class="input-label">
          <span>设计师编号：</span>
        </div>
        <div class="input-value">
          <span>{{orderDetail.desUserCode}}</span>
        </div>
      </div>

      <!-- 设计师昵称 -->
      <div class="input-form-wrap">
        <div class="input-label">
          <span>设计师：</span>
        </div>
        <div class="input-value">
          <span>{{orderDetail.desNickName}}</span>
        </div>
      </div>

      <!-- 设计师联系方式 -->
      <div class="input-form-wrap">
        <div class="input-label">
          <span>联系方式：</span>
        </div>
        <div class="input-value">
          <span>{{orderDetail.desPhone}}</span>
        </div>
      </div>

      <!-- 设计师级别 -->
      <div class="input-form-wrap">
        <div class="input-label">
          <span>设计师级别：</span>
        </div>
        <div class="input-value">
          <dict-tag dict="biz_des_level" :value="orderDetail.desUserLevel" />
        </div>
      </div>

    </div>

    <div class="order-input-wrap" v-else>
      <div class="no-file">
        <i class="el-icon-warning-outline"></i>
        <span>暂无设计师接单</span>
      </div>
    </div>
    <!--正畸  -->
    <detail-data label="矫治方案" :isDown="false" :fileList="fileDataList.designCorrectPlan" :servOrderId="orderDetail.servOrderId" :servCataId="orderDetail.servCataId"
     :orthodonticsData="orderDetail.orthodonticsData" v-if="orderDetail.servCataId=='3010130'&&orderDetail.desUserId">
    </detail-data>
    <detail-data label="模拟视频" :isDown="false" :fileList="fileDataList.designAnalogVideo" :servOrderId="orderDetail.servOrderId" :servCataId="orderDetail.servCataId"
      v-if="orderDetail.servCataId=='3010130'&&orderDetail.desUserId">
    </detail-data>
    <detail-data label="CNC制造文件" :isDown="false" :fileList="orderDetail.designMake" :servOrderId="orderDetail.servOrderId" :servCataId="orderDetail.servCataId"
      v-if="orderDetail.designMake&&orderDetail.desUserId&&orderDetail.servCataId=='3010130'">
    </detail-data>
    <detail-data label="设计方案源文件" :isDown="false" :fileList="orderDetail.designData" :servOrderId="orderDetail.servOrderId" :servCataId="orderDetail.servCataId"
      v-if="orderDetail.designData&&orderDetail.desUserId&&orderDetail.servCataId=='3010130'">
    </detail-data>
   <detail-data label="设计文件" :isDown="false" :fileList="orderDetail.designData" :servOrderId="orderDetail.servOrderId" :servCataId="orderDetail.servCataId"
      v-if="common.serv.get(orderDetail.servCataId).isDesignData === '1' && orderDetail.desUserId&& !plateShow&&orderDetail.servCataId!='3010130'">
    </detail-data>
    <detail-data label="手术报告" :fileList="orderDetail.designReport" :servCataId="orderDetail.servCataId"
      v-if="common.serv.get(orderDetail.servCataId).isDesignReport === '1' && orderDetail.desUserId &&!plateShow">
    </detail-data>
    <detail-data label="种植导板手术规划报告(PDF格式)" :fileList="orderDetail.designReport" :servCataId="orderDetail.servCataId"
      :report="orderDetail.designReport"
      v-if="common.serv.get(orderDetail.servCataId).isDesignReport === '1' && orderDetail.desUserId && plateShow">
    </detail-data>
    <detail-data label="钻针指南文件" :fileList="orderDetail.designGuide" :servCataId="orderDetail.servCataId"
      v-if="common.serv.get(orderDetail.servCataId).isDesignGuide === '1' && orderDetail.desUserId &&!plateShow">
    </detail-data>
    <detail-data label="器械钻针使用流程及注意事项(PDF格式)" :fileList="orderDetail.designGuide" :servCataId="orderDetail.servCataId"
      :guide="orderDetail.designGuide"
      v-if="common.serv.get(orderDetail.servCataId).isDesignGuide === '1' && orderDetail.desUserId && plateShow">
    </detail-data>
    <detail-data label="制造文件" :fileList="orderDetail.designMake" v-if="orderDetail.desUserId&&orderDetail.orderStatus == '99'&&!plateShow&&orderDetail.servCataId!='3010130'">
    </detail-data>
    <detail-data label="种植导板制造文件" :fileList="orderDetail.designMake"
    v-if="orderDetail.orderStatus == '99' && orderDetail.desUserId && plateShow">
    </detail-data>
    <el-button type="primary" plain size="mini" class="resetBtn" v-if="orderDetail.orderStatus == '99'&&orderDetail.servCataId=='3010130'">重启设计需全额缴费，请严格按照确认的矫治方案佩戴矫治牙套</el-button>
  </div>

</template>

<script>
  import DetailData from './components/detailData'
  import BaseTag from '/components/BaseTag'
  import DictTag from '/components/DictTag'
  import {
    mapState
  } from 'vuex'
  export default {
    data(){
      return {
        plateShow:false,
        fileDataList:{},
      }
    },
    props: {
      orderDetail: {
        type: Object,
        default: null
      },
      isUpload: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapState(['common', 'user'])
    },
    methods: {
      downloadFile(downUrl) {
        window.open(downUrl)
      },
      hideInfo(){
        let status = this.orderDetail.orderStatus
        if(status == '99'|| status == '90'||status == '91'||
           status == '92'||status == '98'){
          var str1 = '';
          var str2 = '';
          var str3 = '';
          var str4 = '';
          // console.log('this.orderDetail',this.orderDetail)
          if(this.orderDetail.desNickName){
            for (var i = 0; i < this.orderDetail.desNickName.length-2; i++) {
              str1 +='*'
            }
            for (var i = 0; i < this.orderDetail.desPhone.length-2; i++) {
              str2 +='*'
            }
            str3 =  this.orderDetail.desNickName.slice(0,1)+str1+this.orderDetail.desNickName.slice(-1)
            str4 =  this.orderDetail.desPhone.slice(0,1)+str2+this.orderDetail.desPhone.slice(-1)
            this.orderDetail.desPhone = this.orderDetail.desPhone.slice(0,3)+'****'+this.orderDetail.desPhone.slice(-4)
            this.orderDetail.desNickName = this.orderDetail.desNickName.length == 2? this.orderDetail.desNickName.slice(0,1)+'*':str3;
          }
        }
      },
      JSONToString(){
        this.fileDataList.designCorrectPlan = this.orderDetail.orthodonticsData.designCorrectPlan
        this.fileDataList.designAnalogVideo = this.orderDetail.orthodonticsData.designAnalogVideo
      },
    },
    created() {
      if(this.orderDetail.servCataId == '1010698' ||
         this.orderDetail.servCataId == '1010699'){
        this.plateShow = true
      }
      this.hideInfo();
      this.JSONToString()
    },
    components: {
      BaseTag,
      DetailData,
      DictTag,
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/mixin";
  .input-form-wrap{
    width: 25%;
    padding: 7px 10px;
    display: flex;
    float: left;
    .input-label{
      width: 140px;
      margin-left: 2%;
    }

    /deep/ .input-value {
        width: 180px;
        flex: 0 1 auto;
        padding: 2px 10px;
        border-radius: 4px;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #dcdfe6;
        background-color: #ececec;
        line-height: 20px;
      }
  }
  .resetBtn{
    background: #00A5D5;
    color: white;
    font-size: 13px;
    width: 400px;
    margin: 0 auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// detailDesign.vue?a2725df2